import {ApiService} from '../Api/ApiService';
import {EntityType} from '../Entity';
import {DeleteResponse, FiltersType} from './index';

type ParamsType = {[key: string]: any};

export abstract class AbstractRepository<T extends EntityType, F extends FiltersType> {
  protected abstract baseUrl: string;

  constructor(protected apiService: ApiService) {}

  async findOneById(id: number | string): Promise<T | undefined> {
    return;
  }

  async findAll(filters?: F): Promise<T[]> {
    return [];
  }

  async delete(id: number): Promise<DeleteResponse> {
    let success: boolean = true;
    const url: string = `${this.baseUrl}/${id}`;

    try {
      await this.apiService.delete(url);
    } catch (e) {
      success = false;
    }

    return {
      success: success,
    };
  }
}
